export default "__VITE_ASSET__CH3ufAxX__"